export default __webpack_public_path__ + "static/microsoft-93be8567de0c926b07ca571347df0875.png";